(function () {
  'use strict';

  var CONTAINER_SELECTOR = '[data-newsletter-consent]';
  var CHECKBOX_SELECTOR = '[data-newsletter-consent-checkbox]';
  var ERROR_SELECTOR = '[data-newsletter-consent-error]';

  function showError(container, checkbox) {
    var errorMsg = container.querySelector(ERROR_SELECTOR);
    if (!errorMsg) return;
    var message = container.dataset.errorMessage || 'Required';
    errorMsg.textContent = message;
    errorMsg.removeAttribute('hidden');
  }

  function hideError(container) {
    var errorMsg = container.querySelector(ERROR_SELECTOR);
    if (!errorMsg) return;
    errorMsg.setAttribute('hidden', '');
    errorMsg.textContent = '';
  }

  function validateForm(form) {
    var containers = form.querySelectorAll(CONTAINER_SELECTOR);
    if (!containers.length) return null;
    var firstInvalid = null;
    for (var i = 0; i < containers.length; i++) {
      var container = containers[i];
      var checkbox = container.querySelector(CHECKBOX_SELECTOR);
      if (!checkbox) continue;
      if (!checkbox.checked) {
        showError(container, checkbox);
        if (!firstInvalid) firstInvalid = { container: container, checkbox: checkbox };
      } else {
        hideError(container);
      }
    }
    return firstInvalid;
  }

  function onSubmit(e) {
    var form = e.target;
    if (!form || !form.querySelectorAll) return;
    if (!form.querySelector(CONTAINER_SELECTOR)) return;
    var invalid = validateForm(form);
    if (invalid) {
      e.preventDefault();
      e.stopImmediatePropagation();
      try {
        invalid.checkbox.focus({ preventScroll: true });
      } catch (err) {
        invalid.checkbox.focus();
      }
      try {
        invalid.container.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (err) {
        invalid.container.scrollIntoView();
      }
    }
  }

  function initContainer(container) {
    if (container.dataset.consentInit) return;
    var form = container.closest('form');
    if (!form) return;
    container.dataset.consentInit = 'true';

    if (!form.dataset.newsletterConsentBound) {
      form.dataset.newsletterConsentBound = 'true';
      form.addEventListener('submit', onSubmit, true);
    }

    var checkbox = container.querySelector(CHECKBOX_SELECTOR);
    if (checkbox) {
      checkbox.addEventListener('change', function () {
        if (checkbox.checked) hideError(container);
      });
    }
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var containers = scope.querySelectorAll(CONTAINER_SELECTOR);
    for (var i = 0; i < containers.length; i++) initContainer(containers[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });
})();
